/**
 * Component to display correctly formatted CPD score text.
 */
import { getCpdText } from "@/utils/toolbox";

export default {
  name: "CpdScoreText",
  props: {
    score: { type: Number, default: 0 }, // the score achieved
    maxScore: { type: Number, default: 0 }, // the maximum possible score
    placement: { type: String, default: "right" },
    showTooltip: { type: Boolean, default: true },
    showPercentage: { type: Boolean, default: false },
  },
  computed: {
    cpdText() {
      return getCpdText(Math.ceil(this.score)); // Round up: consistent with the Log It modal and avoids decimal places
    },
    percentage() {
      return this.maxScore ? Math.round((this.score * 100) / this.maxScore) : "-";
    },
  },
};
